import React, { useEffect } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import http from '@/assets/api/http';
import { Row, Col, Typography, InputNumber, message, Space } from 'antd';
import TableBox from './components/TableBox';
import { XTitle } from '@/components/xqxc_ui';
import model from '@/reducers/system/riderlevelset/model';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const { Text } = Typography;

const RiderLevelSet = ({
    history,
    setBreadcrumbPaths,
    match,
    getRatingRules,
    ratingRules: {
        finishOrderScore,
        firstFinishOrderScore,
        inviteRiderScore,
        dayIniviteRiderLimit,
        dayScoreLimit,
        convertRatio
    },
    getLevelList,
    levelList
}) => {


    useEffect(() => {
        getRatingRules();
        getLevelList();
        setBreadcrumbPaths(match); // 自动识别面包屑
    }, []);


    //路由页面跳转
    const onPageJump = (title, url) => {
        const baseUrl = '/home/system/riderlevelset';
        history.push({
            pathname: `${baseUrl}${url}`
        });
    };


    // //表格操作
    // const onTableOperate = (id, type) => {
    //     if (type) {
    //         showConfirm('您确定删除该等级？', '', () => {
    //             http(`/redir/level/del/${id}`, {}, 'POST')
    //                 .then(res => {
    //                     message.success(res.message);
    //                     getLevelList({ pageNum: 1, pageSize: 10000 });
    //                 })
    //                 .catch(error => {
    //                     message.error(error.message);
    //                 });
    //         });
    //     } else {
    //         onPageJump('编辑骑手等级', `/editlevel/${id}`);
    //     }
    // };


    const onBlur = (value, code, type = '') => {
        if (!value) return;
        if (value > 99.999) {
            value = 99.999;
        }
        if (value < 0.001) {
            value = 0.001;
        }
        if (type === 'convert_1') {
            value = `${value}|${(convertRatio.value || "").split("|")[1]}`
        }
        if (type === 'convert_2') {
            value = `${(convertRatio.value || "").split("|")[0]}|${value}`    
        }
        http(
            '/?cmd=com.xqxc.api.pig.mis.biz.rules.LevelScoreRuleService.updateLevelScore',
            { finishOrderScore: { code, value } },
            'POST'
        )
            .then(res => {
                message.success('更新等级分规则成功');
                getRatingRules();
            })
            .catch(error => {
                message.error(error.message);
            });
    };

    return <div className={styles.container}>
        <XTitle
            label='等级分规则'
            style={{ marginBottom: 20 }} />
        <Row gutter={[16, 16]} style={{ paddingLeft: '30px' }}>
            <Col span={7}>
                <Space size='middle'>
                    <Text>完成订单获得</Text>
                    <InputNumber
                        min={1}
                        max={99999}
                        precision={0}
                        value={finishOrderScore.value ? Number(finishOrderScore.value) : 0}
                        onBlur={e => onBlur(e.target.value, finishOrderScore.code)}
                    />
                    <Text>分</Text>
                </Space>
            </Col>
            <Col span={8}>
                <Space>
                    <Text>首次完成订单获得</Text>
                    <InputNumber
                        min={1}
                        max={99999}
                        precision={0}
                        value={firstFinishOrderScore.value ? Number(firstFinishOrderScore.value) : 0}
                        onBlur={e => onBlur(e.target.value, firstFinishOrderScore.code)}
                    />
                    <Text>分</Text>
                </Space>
            </Col>
            <Col span={24}>
                <Space>
                    <Text>邀请骑士注册成功获得</Text>
                    <InputNumber
                        min={1}
                        max={99999}
                        precision={0}
                        value={inviteRiderScore.value ? Number(inviteRiderScore.value) : 0}
                        onBlur={e => onBlur(e.target.value, inviteRiderScore.code)}
                    />
                    <Text>分，每日邀请上限人数</Text>
                    <InputNumber
                        min={1}
                        max={99999}
                        precision={0}
                        value={dayIniviteRiderLimit.value ? Number(dayIniviteRiderLimit.value) : 0}
                        onBlur={e => onBlur(e.target.value, dayIniviteRiderLimit.code)}
                    />
                    <Text>人</Text>
                </Space>
            </Col>
            <Col span={24}>
                <Space>
                    <Text>每日分值获取上限</Text>
                    <InputNumber
                        min={1}
                        max={99999}
                        precision={0}
                        value={dayScoreLimit.value ? Number(dayScoreLimit.value) : 0}
                        onBlur={e => onBlur(e.target.value, dayScoreLimit.code)}
                    />
                    <Text>分</Text>
                </Space>
            </Col>
            <Col span={24}>
                <Space>
                    <Text>转换比例</Text>
                    <Text>等级分:服务分:绿积分=1:</Text>
                    <InputNumber
                        min={0.001}
                        max={99.999}
                        precision={3}
                        value={(convertRatio.value || "").split("|")[0] ? Number((convertRatio.value || "").split("|")[0]) : 0}
                        onBlur={e => onBlur(e.target.value, convertRatio.code,'convert_1')}
                    />
                    <Text>:</Text>
                    <InputNumber
                        min={0.001}
                        max={99.999}
                        precision={3}
                        value={(convertRatio.value || "").split("|")[1] ? Number((convertRatio.value || "").split("|")[1]) : 0}
                        onBlur={e => onBlur(e.target.value, convertRatio.code,'convert_2')}
                    />
                </Space>
            </Col>
        </Row>
        <XTitle
            label='骑手等级'
            style={{ margin: '20px 0' }} />
        <TableBox
            onPageJump={onPageJump}
            levelList={levelList} />
        {/* <XOKButton
            style={{
                width: '100%',
                marginTop: 10
            }}
            label='新增骑手等级'
            onClick={() => onPageJump('新增骑手等级', '/createlevel')}
        /> */}
    </div >;
};
RiderLevelSet.defaultProps = {
    ratingRules: { finishOrderScore: {}, firstFinishOrderScore: {}, inviteRiderScore: {}, dayIniviteRiderLimit: {}, dayScoreLimit: {} ,convertRatio:{} },
    levelList: { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }
};
RiderLevelSet.propTypes = {
    history: PropTypes.object.isRequired,//路由对象
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息
    getRatingRules: PropTypes.func,
    ratingRules: PropTypes.object,
    getLevelList: PropTypes.func,
    levelList: PropTypes.array,
};
export default connect(state => ({
    ratingRules: state.riderLevelSet.ratingRules,
    levelList: state.riderLevelSet.levelList,
}), {
    setBreadcrumbPaths,
    ...model.actions
})(RiderLevelSet);